var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.3333C2 10.3333 4.90909 4.33333 10 4.33333C15.0909 4.33333 18 10.3333 18 10.3333C18 10.3333 15.0909 16.3333 10 16.3333C4.90909 16.3333 2 10.3333 2 10.3333Z",
    stroke: "#014B73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.3333C11.1046 12.3333 12 11.4379 12 10.3333C12 9.22876 11.1046 8.33333 10 8.33333C8.89543 8.33333 8 9.22876 8 10.3333C8 11.4379 8.89543 12.3333 10 12.3333Z",
    stroke: "#014B73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae7039c7d9c4377ca899083b5caa66a0.svg";
export { ForwardRef as ReactComponent };